import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface FeatureListProps {
  /** Items to render, each with a leading check icon. */
  items: string[];
  /** Optional additional classes for the list element. */
  className?: string;
}

/**
 * FeatureList — a compact list of benefits prefixed with a subtle check icon.
 *
 * Replaces the repeated bullet (`•`) lists used across marketing sections with a
 * single consistent, more polished treatment.
 */
export function FeatureList({ items, className = '' }: FeatureListProps): React.ReactElement {
  return (
    <ul className={cn('space-y-2.5 text-sm text-muted-foreground', className)}>
      {items.map((item) => (
        <li key={item} className="flex items-start gap-2.5">
          <Check
            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[hsl(var(--brand-a))]"
            aria-hidden="true"
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
